import { z } from 'zod';
import { ProjectTagIdSchema } from '../dto/ProjectTags.js';
import { ResearchDataEventBaseSchema } from './common.js';
export const ProjectTagDetachedEventSchema = ResearchDataEventBaseSchema.extend({
    subject: z.literal('research-data.project.tag-detached'),
    action: z.literal('tag-detached'),
    data: z
        .object({
        projectId: z.string().guid(),
        tagId: ProjectTagIdSchema,
    })
        .strict(),
}).strict();
//# sourceMappingURL=ProjectTagDetached.js.map